import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { Validators, FormControl } from "@angular/forms";
import * as XLSX from 'xlsx';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
@Component({
  selector: 'app-manage-payout-ledgers',
  templateUrl: './manage-payout-ledgers.component.html',
  styleUrls: ['./manage-payout-ledgers.component.scss']
})
export class ManagePayoutLedgersComponent implements OnInit {
  Tourtransaction: any;
  getinfo: any;
  excelTansactionDataResponse = [];
  symbol = [
    { text: "=", value: "=" },
    { text: "<", value: "<" },
    { text: ">", value: ">" },
    { text: "<=", value: "<=" },
    { text: ">=", value: ">=" },
    { text: "<>", value: "<>" },

  ];
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "1" },
    { text: "current week", value: "2" },
    { text: "Last Week", value: "3" },
    { text: "This Month", value: "4" },
    { text: "Last Month", value: "5" },
    { text: "Custom Date Range", value: "6" }
  ];
  amountcheck = new FormControl("", [Validators.required]);
  EntryDetail = new FormControl("", [Validators.required]);
  TransactionType = new FormControl("", [Validators.required]);
  Amount = new FormControl("", [Validators.required]);
  daterange = new FormControl("", [Validators.required]);
  filtering: boolean = false;
  Dfiltering: boolean = true;
  Rfromdate: boolean = false;
  isStartDateGreaterthenEndDate: boolean = false;
  isCustomDateSelected: boolean = false;
  isreportsbtnActive: boolean = false;
  fromdate = new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
  todate = new FormControl("", [Validators.required]);
  editing = {};
  rows = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;
  rowsSel = [];
  selected = [];
  MerchantKeyId: any;
  loggedinuseremail: any;
  Workclose = false;
  PayoutStep1 = false;
  PayoutStep2 = false;
  PayoutTour = true;
  tourDiv = false;
  constructor(private commonfunction: CommonFunctionService, private transactionservice: TransactionService,) { }

  ngOnInit() {
    this.getinfo = localStorage.getItem('SettingDetails')
    var Transaction = this.getinfo;
    let jsonObj: any = JSON.parse(this.getinfo);

    if (jsonObj != null) {
      this.Tourtransaction = jsonObj.ProductKnowledgeGuide_ProductTourPayoutLedger;
      if (this.Tourtransaction == false) {
        this.SkipTour();
      }
    }
    this.GetPayOutLedgers();
  }
  ShowMeAgain() {
    var Type = "PayOut Ledger";
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.transactionservice.UpdateManageTransactionSettings(merchantdata.MerchantKeyId, merchantdata.UserId, Type).subscribe(result => {
      if (result != null) {
        localStorage.removeItem('SettingDetails');
        this.transactionservice.GetUserPreferenceSettings(merchantdata.MerchantKeyId, merchantdata.UserId).subscribe(result => {
          if (result != null) {
            localStorage.setItem("SettingDetails", JSON.stringify(result));
            window.location.reload();
          }
        });
      }
    });
  }
  checkRangeType() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
      this.fromdate.setValue('');
      this.todate.setValue('');
      this.isreportsbtnActive = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
    }
  }
  GetPayOutLedgers() {


    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.loggedinuseremail = this.commonfunction.getUserId();
    // this.loggedinuseremail=null;

    this.MerchantKeyId = merchantdata.MerchantKeyId;

    this.GetPayOutLedgersList((data) => {
      // cache our list
      this.temp = _clone(data);
      this.rows = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);

    });
  }

  GetPayOutLedgersList(cb) {
    const req = new XMLHttpRequest();
    this.loggedinuseremail = null;
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    req.open('GET', environment.GetPayOutLedgersList + "?MerchantKeyId=" + this.MerchantKeyId + "&UserId=" + this.loggedinuseremail + "&LoginUserId=" + merchantdata.UserId
    );

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }
  filters() {
    this.filtering = !this.filtering;
  }
  selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
      this.search();

    }
  }
  search() {
    this.GetPayOutledgerfilter((data) => {
      // cache our list
      this.temp = _clone(data);
      this.rows = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
    });

  }
  GetPayOutledgerfilter(cb) {
    var daterange = this.daterange.value;
    var TransactionType = this.TransactionType.value;
    var Amount = this.Amount.value;
    var EntryDetail = this.EntryDetail.value;
    var amountcompare = this.amountcheck.value;

    if (Amount == "") {
      Amount = '0';
    }

    if (daterange == "Today") {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);


    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;

    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);
    }

    const req = new XMLHttpRequest();
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    req.open('GET',
      environment.viewPayoutledgerFilterdataurl + "?MerchantKeyId=" + this.MerchantKeyId + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1
      + "&TransactionType=" + TransactionType + "&Amount=" + Amount + "&AmountCheck=" + amountcompare+ "&LoginUserId="+merchantdata.UserId);
    req.onload = () => {
      cb(JSON.parse(req.response));
    };


    var TransactionType = this.TransactionType.value;

    req.send();
  }
  close() {
    this.Workclose = false;
  }
  Nextstep() {
    this.PayoutStep1 = false;
    this.PayoutStep2 = false;
    this.PayoutTour = false;
    this.tourDiv = true;

  }

  GetStarted() {
    this.PayoutStep2 = false;
    this.PayoutTour = true;
    this.tourDiv = false;
    this.PayoutStep1 = false;
  }
  backSubmit() {
    this.PayoutStep1 = true;
    this.PayoutStep2 = false;
    this.PayoutTour = false;
    this.tourDiv = true;

  }
  GotoTour() {
    this.tourDiv = true;
    this.PayoutTour = false;
    this.PayoutStep2 = false;
    this.PayoutStep1 = true;

  }
  SkipTour() {
    this.tourDiv = false;
    this.PayoutTour = true;
    this.PayoutStep2 = false;
    this.PayoutStep1 = false;
  }
  checkDateRange() {
    if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = true;
      }
      else {
        this.isreportsbtnActive = true;
        this.isStartDateGreaterthenEndDate = false;
      }
    }
    else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
    }
  }
  readAndExportToExcelData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    if (this.rows.length > 0) {
      this.rows.forEach(element => {

        var manageTranArray = {
          'TransactionType': element.TransactionType, 'EntryDetail': element.EntryDetail,
          'Amount': element.Amount, 'Status': element.Status, 'Balance': element.Balance, 'DateTime': element.UpdatedDateTime
        }
        this.excelTansactionDataResponse.push(manageTranArray);
      });

      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse,
        { header: ['TransactionType', 'EntryDetail', 'Amount', 'Status', 'Balance', 'DateTime'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'ManageTransaction_tbl');
    }
    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.xlsx');
    this.excelTansactionDataResponse = [];
  }

}
